module.exports = ".card {\n  -webkit-box-shadow: 1px 1px 3px 0px;\n          box-shadow: 1px 1px 3px 0px;\n}\n\n.card-body {\n  padding: 4rem 1.25rem;\n}\n\n.row {\n  margin-bottom: 14px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main